import { useContext } from 'react';
import { SastaWalletContext } from './context';

export function useSastaWallet() {
  const context = useContext(SastaWalletContext);

  if (context === undefined) {
    throw new Error('useSastaWallet must be used within SastaWalletContextProvider');
  }

  return context;
}
